import { Box, Flex } from '@chakra-ui/react';
import {
  Avatar,
  AvatarImage,
  ListItemComp,
  ListItemCompContent,
  ListItemCompDescription,
  ListItemCompLeading,
  ListItemCompTitle,
} from '@mesh.ai/rabbit';

import { DateComp } from 'uiToolkitV1/DateComp';
import { TagColored } from 'uiToolkitV1/Tag';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

type ReviewsMobileViewCellProps = {
  profilePhoto?: string;
  name: string;
  subTitle?: string;
  description: {
    title: string;
    dateProps?: {
      date: string;
      isRelativeDateFormat?: boolean;
      enableRelativeFormatDistanceColor?: boolean;
    };
    text?: string;
  };
  tagProps?: {
    color: string;
    text: string;
  };
};

export const ReviewsMobileViewCell = ({
  profilePhoto,
  name,
  subTitle,
  description,
  tagProps,
}: ReviewsMobileViewCellProps) => (
  <Box w="100%">
    <ListItemComp style={{ padding: '0px' }}>
      {profilePhoto && (
        <ListItemCompLeading>
          <Avatar>
            <AvatarImage src={profilePhoto} />
          </Avatar>
        </ListItemCompLeading>
      )}
      <ListItemCompContent>
        <ListItemCompTitle>{name}</ListItemCompTitle>
        {subTitle && <ListItemCompDescription>{subTitle}</ListItemCompDescription>}
      </ListItemCompContent>
    </ListItemComp>
    <Flex>
      <Flex
        ml={profilePhoto ? '32px' : '0px'}
        minW={description.dateProps || description.text ? '120px' : '0px'}
        gap="2px"
        alignItems="center"
        flexShrink={0}
      >
        <TextBodyMedium>{description.title}: </TextBodyMedium>
        {description.dateProps ? (
          <DateComp {...description.dateProps} />
        ) : (
          <TextBodyMedium>{description.text || ''}</TextBodyMedium>
        )}
      </Flex>
      {tagProps && (
        <TagColored ml="8px" color={tagProps.color} flexShrink={0}>
          {tagProps.text}
        </TagColored>
      )}
    </Flex>
  </Box>
);
